import axios from '@/utils/axios.js'
/**
 * 获取字典项列表
 * @param {*} queryParams 查询参数
 * @returns 字典项列表
 */
export async function getDictItems(queryParams) {
  const { data } = await axios.get('/admin/dictItem', { params: queryParams })
  return data
}

/**
 * 根据 id 查询字典项
 * @param {*} dictItemId 字典项 id
 * @returns 字典项
 */
export async function getDictItemById(dictItemId) {
  const { data } = await axios.get(`/admin/dictItem/${dictItemId}`)
  return data
}

/**
 * 根据字典类型查询字典项列表
 * @param {*} dictType 字典类型
 * @returns 字典项列表
 */
export async function getDictItemsByDictType(dictType) {
  const { data } = await axios.get('/admin/dictItem/dictType', {
    params: { dictType: dictType }
  })
  return data
}

/**
 * 创建字典项
 * @param {*} dictItem 字典项
 */
export async function createDictItem(dictItem) {
  await axios.post('/admin/dictItem', dictItem)
}

/**
 * 修改字典项
 * @param {*} dictItem 字典项
 */
export async function updateDictItem(dictItem) {
  await axios.put('/admin/dictItem', dictItem)
}

/**
 * 根据 id 删除字典项
 * @param {*} dictItemId 字典项 id
 */
export async function deleteDictItemsByIds(dictItemId) {
  await axios.delete(`/admin/dictItem/${dictItemId}`)
}
